import React from 'react';
import { PaletteColor, Stack, styled, Theme, useTheme } from '@mui/material';
import { SxProps } from '@mui/system';

// Define a type for your custom props
interface StepProps {
    active: boolean;
    activeColor: PaletteColor;
    sx?: SxProps<Theme>;
}

export type ClickableMobileStepperProps = {
    activeStep: number;
    steps: number;
    onStepClick: (step: number) => void;
    activeColor: string;
}

const ClickableMobileStepper = ({ activeStep, steps, onStepClick, activeColor } : ClickableMobileStepperProps) => {

    const theme = useTheme();

    return (
        <StepsContainer>
            {Array.from(Array(steps).keys()).map((step) => (
            <Step activeColor={activeColor === "error" ? theme.palette.error : theme.palette.primary } key={step} onClick={() => onStepClick(step)} active={activeStep === step} />
            ))}
        </StepsContainer>
    )

};

export default ClickableMobileStepper;

const StepsContainer = styled(Stack)(({ theme }) => ({
    backgroundColor: 'transparent',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: theme.spacing(2),
}));

// Use the custom props in your styled component
const Step = styled('button')<StepProps>(({ theme, active, activeColor }) => ({
    padding: 0,
    border: 0,
    height: '12px',
    width: '12px',
    borderRadius: '50%',
    backgroundColor: active ? activeColor.main : theme.palette.grey[400],
    cursor: 'pointer',
    transition: "background-color 0.3s"
}));